<template>
  <HomeBanner />
  <HomeAnchor />
  <!--<HomeVideo />-->
  <HomeCore />
  <HomeHighlight />
  <HomePlan />
  <HomeCase />
  <!-- <HomeExperience /> -->
</template>

<script lang="ts" type="text/tsx">
import HomeBanner from '@template/page/home/homeBanner.vue';
import HomeAnchor from '@template/page/home/homeAnchor.vue';
// import HomeVideo from '@template/page/home/homeVideo.vue';
import HomeCore from '@template/page/home/homeCore.vue';
import HomeHighlight from '@template/page/home/homeHighlight.vue';
import HomePlan from '@template/page/home/homePlan.vue';
import HomeCase from '@template/page/home/homeCase.vue';
// import HomeExperience from '@template/page/home/homeExperience.vue';

export default {
  name: 'home',
  components: {
    HomeBanner,
    HomeAnchor,
    // HomeVideo,
    HomeCore,
    HomeHighlight,
    HomePlan,
    HomeCase,
    // HomeExperience
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/home/';
</style>